'use client';

import { Toaster as Sonner, type ToasterProps } from 'sonner';

export function Toaster({ ...props }: ToasterProps) {
  return (
    <Sonner
      theme="system"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast: 'border border-border bg-card text-foreground shadow-[var(--shadow-md)]',
          description: 'text-muted-foreground',
        },
      }}
      {...props}
    />
  );
}
